import { render, staticRenderFns } from "./com-info.vue?vue&type=template&id=f606758e&scoped=true"
var script = {}
import style0 from "./com-info.vue?vue&type=style&index=0&id=f606758e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f606758e",
  null
  
)

export default component.exports